import { render } from "./DashboardUsers.vue?vue&type=template&id=4ca22540"
import script from "./DashboardUsers.vue?vue&type=script&lang=js"
export * from "./DashboardUsers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__